import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { TabsWithCards, TabsDataType } from "@/patterns/tabs-with-cards";

import {
    EnterpriseStrategyAndPlanning,
    EnterpriseServiceManagement,
    EnterpriseSoftwareDevelopment,
    EnterpriseWorkManagement
} from "../tab-contents";

export const TabsSection = () => {
    const intl = useIntl();

    const tabs: TabsDataType = [
        {
            id: "tab1",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.softwareDevelopment",
                defaultMessage: "Software development"
            }),
            englishLabel: "Software development",
            tabComponent: <EnterpriseSoftwareDevelopment />
        },
        {
            id: "tab2",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.Service management",
                defaultMessage: "Service management"
            }),
            englishLabel: "Service management",
            tabComponent: <EnterpriseServiceManagement />
        },
        {
            id: "tab3",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.enterpriseStrategyAndPlanning",
                defaultMessage: "Enterprise strategy & planning"
            }),
            englishLabel: "Enterprise strategy & planning",
            tabComponent: <EnterpriseStrategyAndPlanning />
        },
        {
            id: "tab4",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.workManagement",
                defaultMessage: "Work management"
            }),
            englishLabel: "Work management",
            tabComponent: <EnterpriseWorkManagement />
        }
    ];

    const solutionsHeader = intl.formatMessage({
        id: "EnterpriseLandingPage.solutions.header",
        defaultMessage: "Industry-leading solutions to accelerate your business"
    });

    return (
        <UFOSegment name="enterprise-page-tabs">
            <TabsWithCards h2Text={solutionsHeader} tabsData={tabs} />
        </UFOSegment>
    );
};
